export default __webpack_public_path__ + "static/media/Oliver_ParticleSmoke-36.11f42938.png";